module.exports = __webpack_public_path__ + "static/media/sign.cf8b686b.jpg";